<template>
  <form @submit.prevent="handleSubmit">
    <input
      v-model="displayName"
      type="text"
      required
      placeholder="name"
    >
    <label>{{ classTeacher.state.grade }}</label>
    <button>Create</button>
  </form>
</template>

<script>
import { ref } from 'vue'
import { db, serverTimestamp, addDoc, collection } from '@/firebase/config'

export default {
  props: ['classTeacher'],
  setup (props, context) {
    const displayName = ref('')

    const handleSubmit = async () => {
      const post = {
        displayName: displayName.value,
        grade: props.classTeacher.state.grade,
        createdAt: serverTimestamp(),
        createdBy: props.classTeacher.state.user.displayName
      }

      await addDoc(collection(db,
        '/schools/inspire-schools/' + props.classTeacher.state.grade +
        '/reports/teacher'), post)
      context.emit('newClassAnnouncementCreated')
      displayName.value = ''
    }

    return { displayName, handleSubmit }
  }
}
</script>

<style scoped>
  label {
    display: block;
  }
</style>
